(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6781],{

/***/ 97896:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-insurance",
      function () {
        return __webpack_require__(53994);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 53994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36456);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _utils_is_in_explained_blocklist__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72487);
/* harmony import */ var _src_client_models_table_of_contents_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3971);
/* harmony import */ var _src_client_pages_consideration_landing__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65526);
/* harmony import */ var _src_client_utils_filter_offers_by_product_type__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41763);
/* harmony import */ var _src_client_pages_consideration_landing_utils_get_content_to_render__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29873);
/* harmony import */ var _src_client_utils_get_should_skip_client_side_request__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14033);
/* harmony import */ var _src_client_selectors_select_customer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34112);
/* harmony import */ var _src_client_selectors_select_has_partner_referrer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93830);
/* harmony import */ var _src_client_selectors_select_target_segment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(80622);
/* harmony import */ var _src_client_pages_explained_term_detail_utils_use_get_explained_term__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(98593);
/* harmony import */ var _utils_use_get_offers_content__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(68085);
/* harmony import */ var _src_client_cms_utils_use_table_of_contents__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(30329);
















var slug = _utils_is_in_explained_blocklist__WEBPACK_IMPORTED_MODULE_4__/* .EXPLAINED_TERMS_SLUG_BLOCKLIST.HEALTH_INSURANCE_LANDING_PAGE */ .z.HEALTH_INSURANCE_LANDING_PAGE;
var contactTitle = "Need help choosing a cover?";
var HealthInsurancePage = function(param) {
    var serverSideOffers = param.activeOffers, serverSidePlaceholders = param.placeholders, serverSideData = param.serverSideData;
    var shouldSkip = (0,_src_client_utils_get_should_skip_client_side_request__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
    var ref = (0,_utils_use_get_offers_content__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
        shouldSkip: shouldSkip
    }), activeOffers = ref.activeOffers, placeholders = ref.placeholders, isOfferContentLoading = ref.loading;
    // Refetch content for time travel?
    var ref1 = (0,_src_client_cms_utils_use_table_of_contents__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
        fragment: _src_client_models_table_of_contents_constants__WEBPACK_IMPORTED_MODULE_5__/* .FRAGMENTS.CONTACTS */ .Y.CONTACTS,
        skip: shouldSkip,
        slug: _src_client_models_table_of_contents_constants__WEBPACK_IMPORTED_MODULE_5__/* .SLUG.LOOKING_TO_JOIN_CONTACTS */ .T.LOOKING_TO_JOIN_CONTACTS
    }), contactItems = ref1.items, isLoadingContact = ref1.loading;
    var ref2 = (0,_src_client_pages_explained_term_detail_utils_use_get_explained_term__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        skip: shouldSkip,
        slug: slug
    }), explainedTermData = ref2.explainedTerm, isLoadingExplainedTerm = ref2.isLoading;
    var isPartnerReferral = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_src_client_selectors_select_has_partner_referrer__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z);
    var customer = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_src_client_selectors_select_customer__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z);
    var targetSegment = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_src_client_selectors_select_target_segment__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z);
    var isLoading = isLoadingExplainedTerm || isLoadingContact;
    var clientSideData = {
        contact: {
            items: contactItems,
            name: contactTitle
        },
        explainedTerm: explainedTermData
    };
    var cmsData = isLoading || shouldSkip ? serverSideData : clientSideData;
    var offersContent = shouldSkip || isOfferContentLoading ? {
        activeOffers: serverSideOffers,
        placeholders: serverSidePlaceholders
    } : {
        activeOffers: activeOffers,
        placeholders: placeholders
    };
    var filteredOffer = (0,_src_client_utils_filter_offers_by_product_type__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(customer === null || customer === void 0 ? void 0 : customer.productType, offersContent.activeOffers);
    var offerProps = {
        overrideOffers: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.compact)([
            filteredOffer
        ]),
        placeholders: offersContent.placeholders,
        targetSegment: targetSegment
    };
    var offerContentToRender = filteredOffer && !isPartnerReferral ? offerProps : null;
    var considerationContent = (0,_src_client_pages_consideration_landing_utils_get_content_to_render__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        cmsData: cmsData,
        offerContentToRender: offerContentToRender
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_client_pages_consideration_landing__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        content: considerationContent
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (HealthInsurancePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6950,8761,1372,6964,1849,9143,7022,3666,9835,4059,603,9664,408,9774,2888,179], function() { return __webpack_exec__(97896); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);